import {FC} from 'react';
import {useUiState} from '../../hooks/usePlayerState';
import * as Styles from './timestamp.styles';
import {formatTimestampByDuration} from '../../utils/renderTimestamp';

export const TimeStamp: FC = () => {
  const [state] = useUiState();
  const {duration, isLive, timestamp} = state.context;

  // Don't render a timestamp on live videos.
  if (isLive) return null;

  return (
    <Styles.Container>
      <Styles.Segment>
        {formatTimestampByDuration(timestamp, duration)}
      </Styles.Segment>
      <Styles.Segment>/</Styles.Segment>
      <Styles.Segment>
        {formatTimestampByDuration(duration, duration)}
      </Styles.Segment>
    </Styles.Container>
  );
};
